// Estimates only reserve offscreen space. Mounted rows retain their natural height.
export function getRowOffsets(rows: { id: string; kind: string }[], heights: Map<string, number>) {
	const offsets = [0]
	rows.forEach((row, index) => {
		offsets.push(
			offsets[index] +
				(heights.get(row.id) ?? (row.kind === 'task' || row.kind === 'rework' ? 77 : 73)),
		)
	})
	return offsets
}

export function getVirtualRange(
	offsets: number[],
	scrollTop: number,
	viewportHeight: number,
	overscan = 5,
) {
	const count = offsets.length - 1
	const total = offsets[count]
	const top = Math.max(0, Math.min(scrollTop, Math.max(0, total - viewportHeight)))
	const indexAt = (offset: number) => {
		let low = 0
		let high = count
		while (low < high) {
			const middle = Math.floor((low + high) / 2)
			if (offsets[middle + 1] <= offset) low = middle + 1
			else high = middle
		}
		return low
	}
	const start = Math.max(0, indexAt(top) - overscan)
	const end = Math.min(count, indexAt(top + viewportHeight) + 1 + overscan)
	return { start, end, paddingTop: offsets[start], paddingBottom: total - offsets[end] }
}
